import Vue from 'vue'
import Router from 'vue-router'
import ProjectStatusPage from '../components/ProjectStatusPage'
import NotMergedProjects from '../components/NotMergedProjects'
import ChangeList from '../components/ChangeList'
import Login from '../components/Login'
import Api from '../Api'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      name: 'ProjectStatusPage',
      meta: {
        requireAuth: true
      },
      component: ProjectStatusPage
    },
    {
      path: '/notmerged',
      name: 'NotMergedProjects',
      meta: {
        requireAuth: true
      },
      component: NotMergedProjects
    },
    {
      path: '/changes',
      name: 'ChangeList',
      meta: {
        requireAuth: true
      },
      component: ChangeList,
      props: true
    },
    {
      path: '/changes/:from/:to/:project',
      name: 'ChangeListParams',
      meta: {
        requireAuth: true
      },
      component: ChangeList,
      props: true
    },
    {
      path: '/login',
      name: 'Login',
      meta: {
        requireAuth: false
      },
      component: Login
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth && !Api.isLoggedIn()) {
    localStorage.setItem('redirectAfterLogin', to.fullPath)
    next('/login')
  }
  next()
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js